'use client';

import { Contact } from "@/app/lib/generated/graphql-types";
import { Skeleton, Stack, styled, Typography } from "@mui/material";
import LinkOptional from "@/app/features/shared/__to_be_integrated/ui/LinkOptional";
import { Mail, Phone } from "@mui/icons-material";
import { formattedPhoneNumber } from "@/app/features/shared/helper/formattedPhoneNumber";
import { ReactNode } from "react";

export default function FooterContactLinksView({ contact }: { contact: Contact }) {

    const telLinkAddress = formattedPhoneNumber(contact.phone.number);

    return (
        <Wrapper
            mailContent={
                <>
                    <Mail />
                    <Typography variant="body2">
                        <StyledLinkOptional href={`mailto:${contact.emailAddress}`}>{contact.emailAddress}</StyledLinkOptional>
                    </Typography>
                </>
            }
            phoneContent={
                <>
                    <Phone />
                    <Typography variant="body2">
                        <StyledLinkOptional href={telLinkAddress}>{contact.phone.number}</StyledLinkOptional>
                    </Typography>
                </>
            }
        />
    )
}

export function FooterContactLinksViewSkeleton() {
    return (
        <Wrapper
            mailContent={
                <>
                    <Mail />
                    <Skeleton variant="text" width="100%">
                        <Typography variant="body2">someemailadress@example.com</Typography>
                    </Skeleton>
                </>
            }
            phoneContent={
                <>
                    <Phone />
                    <Skeleton variant="text" width="100%">
                        <Typography variant="body2">+00 1234 56789</Typography>
                    </Skeleton>
                </>
            }
        />
    )
}

function Wrapper({ mailContent, phoneContent }: { mailContent: ReactNode, phoneContent: ReactNode }) {
    return (
        <>
            <Stack spacing={{ xs: 4, md: 2 }} direction="row" sx={{ width: '100%', alignItems: 'center' }}>{mailContent}</Stack>
            <Stack spacing={{ xs: 4, md: 2 }} direction="row" sx={{ width: '100%', alignItems: 'center' }}>{phoneContent}</Stack>
        </>
    )
}

const StyledLinkOptional = styled(LinkOptional, {
    shouldForwardProp: (prop) => prop !== 'primary'
})<{ primary?: boolean }>(({ theme, primary = false }) => ({
    color: primary ? theme.palette.primary.main : undefined,
    '&:hover': {
        color: theme.palette.primary.main,
    }
}));